import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSpotlight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"spotlight, focus, shooting, studio"} maskId="square-filled-radius-0-stroke-1-IconSpotlight"><path fillRule="evenodd" clipRule="evenodd" d="M22.207 8.83301L19.04 12L22.207 15.167L15.167 22.207L12 19.04L8.83301 22.207L1.79297 15.167L4.95996 12L1.79297 8.83301L8.83301 1.79297L12 4.95996L15.167 1.79297L22.207 8.83301ZM6.37402 12L12 17.626L17.626 12L12 6.37402L6.37402 12Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSpotlight;
